module.exports = __webpack_public_path__ + "static/media/apple-pay.3f4e6ebf.svg";